<template>
  <h3 class="pb5">Rapport statistique des dossiers par catégories (CDX_0140)</h3>
  <CritereRechercheStatistiques :show-categorie="false" ref="critereRechercheStatistiques"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheStatistiques from "@/components/rapports/Rechercher/CritereRechercheStatistiques.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "DossiersStatistiqueDossierCategories",
  components: {CritereRechercheStatistiques, ButtonBar},
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Statistiques");
    this.isRechercheDataLoading = true;
    this.$store.dispatch("dossier/rechercherDefaut48HeuresAction")
        .then((res) => {
          this.assignerResultat(res);
          this.isRechercheDataLoading = false;
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerResultat(res) {
      this.$root.$refs.messagesComp.messagesList = res.data.messages;
      this.$refs.critereRechercheStatistiques.assignerListe(res.data.entiteDecision);
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheStatistiques.getCritereRecherche();
      criteresRapportVO.titre = "DossiersStatistiqueDossierCategories";
      criteresRapportVO.nomRapport = "statistiques.CategorieStatistiqueDossierGenererRapportSQL_CDX_0140";
      this.$store.dispatch("rapports/obtenirRapportAction",
          criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>

<style scoped>

</style>